export default __webpack_public_path__ + "static/media/emptyState.84451727.png";